import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function RequireAdmin({ children }) {
  const { isAdmin, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-[#0B2545]" />
      </div>
    );
  }
  if (!isAdmin) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}
